export const VIEWS = {
  SANDBOX: 'SANDBOX',
  FEEDBACK: 'FEEDBACK',
  SURVEYS: 'SURVEYS',
  SETTINGS: 'SETTINGS',
}

export const TYPES = {
  TEXT_ANSWER: 'TEXT_ANSWER',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTI_CHOICE: 'MULTI_CHOICE',
  SCORE: 'SCORE',
}
